import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "100%",
		position: "relative",
		backgroundColor: theme.palette.colors.white,
		border: `1px solid ${theme.palette.colors.disabled}`,
		borderTop: "none",
		boxShadow: "inset 0 -5px 5px 0 rgba(0, 0, 0, 0.05)",
		display: "flex",
		"&:last-child": {
			borderBottomRightRadius: "10px",
			borderBottomLeftRadius: "10px",
			boxShadow: "none",
		},
	},
	cell: {
		borderRight: `1px solid ${theme.palette.colors.disabled}`,
		padding: "22px 36px",
		"&:last-child": {
			borderRight: "none",
		},
	},
	tariffInfoCell: {
		width: "390px",
	},
	measureCell: {
		width: "175px",
		textAlign: "center",
		padding: "22px 20px !important",
	},
	minCell: {},
	gbCell: {},
	smsCell: {
		display: "none",
	},
	unlimitedSocialCell: {
		display: "none",
	},
	priceCell: {},
	buttonsWrapper: {
		width: "263px",
		padding: "22px 18px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "space-around",
	},
	priceInButton: {
		display: "none",
	},
	connectButton: {},
	logo: {},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		cell: {
			padding: "22px 33px",
		},
		tariffInfoCell: {
			width: "305px",
		},
		measureCell: {
			width: "135px",
			textAlign: "center",
			padding: "22px 16px !important",
		},
		buttonsWrapper: {
			width: "228px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		cell: {
			padding: "16px 25px",
		},
		tariffInfoCell: {
			width: "200px",
		},
		measureCell: {
			width: "110px",
			textAlign: "center",
			padding: "16px 5px !important",
		},
		buttonsWrapper: {
			width: "180px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			borderTop: `1px solid ${theme.palette.colors.disabled}`,
			boxShadow: "none",
			display: "flex",
			borderRadius: "10px",
			flexWrap: "wrap",
			marginBottom: "16px",
			"&:first-child": {
				borderRadius: "10px",
			},
			"&:last-child": {
				borderRadius: "10px",
				boxShadow: "none",
			},
		},
		cell: {
			padding: "15px 30px",
			borderRight: "none",
			borderBottom: `1px solid ${theme.palette.colors.disabled}`,
			"&:last-child": {
				borderRight: "none",
				borderBottom: "none",
			},
		},
		tariffInfoCell: {
			width: "100%",
		},
		measureCell: {
			width: "33%",
			textAlign: "center",
		},
		minCell: {
			padding: "15px 9px 15px 30px !important",
		},
		gbCell: {
			flexGrow: 1,
			padding: "15px 9px !important",
		},
		smsCell: {
			display: "block",
			padding: "15px 30px 15px 9px !important",
		},
		unlimitedSocialCell: {
			display: "block",
			flexGrow: 1,
			padding: "15px 30px !important",
		},
		priceCell: {
			display: "none",
		},
		buttonsWrapper: {
			width: "100%",
			flexDirection: "row",
			alignItems: "center",
			display: "flex",
			padding: 0,
		},
		priceInButton: {
			display: "block",
			width: "50%",
			padding: "15px 15px 15px 30px",
		},
		connectButton: {
			width: "50%",
			height: "100%",
			borderRadius: "0 0 10px 0",
		},
		logo: {
			display: "none",
		},
	},
	[`@media (max-width: ${theme.media.xs})`]: {
		priceInButton: {
			padding: "15px 10px 15px 10px",
		},
	},
}));

const TarifficationCItem = ({
	eliteComponent,
	tariffInfo,
	unlimitedSocial,
	minutesComponent,
	internetComponent,
	smsComponent,
	buttons,
	priceComponent,
	logoComponent,
	linkComponent,
	generateProviderRates,
	tariff,
	onClickConnect,
}) => {
	const classes = useStyles();

	const preventPropagation = (e) => {
		e.stopPropagation();
	};
	return (
		<div className={classes.root}>
			{eliteComponent}
			<div className={classNames(classes.cell, classes.tariffInfoCell)}>{tariffInfo}</div>
			<div className={classNames(classes.measureCell, classes.cell, classes.minCell)}>
				{minutesComponent}
			</div>
			<div className={classNames(classes.measureCell, classes.cell, classes.gbCell)}>
				{internetComponent}
			</div>
			<div className={classNames(classes.measureCell, classes.cell, classes.smsCell)}>
				{smsComponent}
			</div>
			{!!unlimitedSocial && (
				<div className={classNames(classes.measureCell, classes.cell, classes.unlimitedSocialCell)}>
					{unlimitedSocial}
				</div>
			)}
			<div className={classNames(classes.measureCell, classes.cell, classes.priceCell)}>
				{priceComponent}
			</div>
			<div className={classNames(classes.buttonsWrapper, classes.cell)}>
				{React.cloneElement(linkComponent, {
					onClick: preventPropagation,
					to: generateProviderRates(tariff),
					className: classes.logo,
					children: logoComponent,
				})}
				<div className={classNames(classes.priceInButton)}>{priceComponent}</div>
				<div className={classes.connectButton} onClick={() => !!onClickConnect && onClickConnect()}>
					{buttons}
				</div>
			</div>
		</div>
	);
};

export default TarifficationCItem;
